module.exports = __webpack_public_path__ + "static/media/domotica-y-iot.04b87469.png";